import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { Video } from '../../../../api/generated/data-contracts';
import { GET_HELP_VIDEOS } from '../../../../constants/queryKeys';

export function useHelpVideos(
    options?: Omit<UseQueryOptions<Video[], unknown, Video[], string[]>, 'initialData' | 'queryKey' | 'queryFn'> & {
        initialData?: () => undefined;
    },
) {
    return {
        ...useQuery({
            queryKey: [GET_HELP_VIDEOS],
            queryFn: () => ApiCalls.getVideos({}).then(res => res.data.toSorted((a, b) => (a.order < b.order ? -1 : 1))),
            ...(options || {}),
        }),
        queryKey: [GET_HELP_VIDEOS],
    };
}
